// Réinitialisation du mot de passe — backend Avsoft (appels publics, avant login).
import { avsoftClient } from "../../shared/api/clients";

export interface OtpResponse {
  success: boolean;
  message?: string;
}

const publicPost = (path: string, body: unknown) =>
  avsoftClient
    .post<OtpResponse>(path, body, { auth: false })
    .then(({ data }) => data);

export const sendOtp = (email: string, purpose = "reset") =>
  publicPost("/otp/send-otp", { Email: email, Purpose: purpose });

export const verifyOtp = (email: string, code: string) =>
  publicPost("/otp/verify-otp", { Email: email, Code: code });

export const deleteExpiredOtp = (email: string) =>
  publicPost("/otp/delete-expired-otp", { Email: email });

/** Le mot de passe est envoyé en clair (HTTPS) : le backend le chiffre lui-même. */
export const resetPassword = (email: string, newPassword: string) =>
  publicPost("/otp/reset-password", {
    Email: email,
    NewPassword: newPassword,
    ConfirmPassword: newPassword,
  });

export const cancelPasswordReset = (email: string) =>
  publicPost("/otp/cancel-password-reset", { Email: email });
